<script lang="ts" setup>
import {useSiteLayout} from "~/composables/useSiteLayout";

const {mobileMenuOpen} = useSiteLayout();
const {t} = useI18n();
</script>

<template>
  <button class="inline-flex laptop:hidden items-center justify-center rounded-md p-2.5 text-secondary relative z-20"
          type="button"
          @click="mobileMenuOpen = !mobileMenuOpen">
    <span v-if="!mobileMenuOpen" class="sr-only">{{ t('action.open_menu') }}</span>
    <span v-if="mobileMenuOpen" class="sr-only">{{ t('action.close_menu') }}</span>
    <svg
            class="w-6 h-6"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
    >
      <Transition name="fade">
        <path
                v-if="mobileMenuOpen"
                clip-rule="evenodd"
                d="M18.278 16.864a1 1 0 01-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 01-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 011.414-1.414l4.829 4.828 4.828-4.828a1 1 0 111.414 1.414l-4.828 4.829 4.828 4.828z"
                fill-rule="evenodd"
        ></path>
        <path
                v-else
                d="M4 5h16a1 1 0 010 2H4a1 1 0 110-2zm0 6h16a1 1 0 010 2H4a1 1 0 010-2zm0 6h16a1 1 0 010 2H4a1 1 0 010-2z"
                fill-rule="evenodd"
        ></path>
      </Transition>
    </svg>
  </button>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>